export default "__VITE_ASSET__BDcGzUl3__"